import script from "./ActiveStudentAccountAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActiveStudentAccountAmount.vue?vue&type=script&setup=true&lang=ts"

import "./ActiveStudentAccountAmount.vue?vue&type=style&index=0&id=93832ed0&scoped=true&lang=css"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93832ed0"]])

export default __exports__